// ─────────────────────────────────────────────────────────────
//  Дизайн-токены: цвета, градиенты, общие настройки
// ─────────────────────────────────────────────────────────────
export const C = {
  hero: 'linear-gradient(180deg, #9f78dc 0%, #bda0ed 55%, #d9c9fa 100%)',
  heroDeep: 'linear-gradient(160deg, #8053bd 0%, #9d73d4 100%)',
  bg: '#d7c5f4',
  white: 'rgba(255,255,255,.28)',
  dark: '#4b3465',
  grey: '#826f92',
  greyLight: '#ad98c4',
  border: 'rgba(255,255,255,.5)',
  blue: '#7650a6',
  blueBg: 'rgba(255,255,255,.24)',
  orange: '#B86840',
  orangeBg: '#F8EBE0',
  purple: '#7f53b9',
  purpleBg: 'rgba(255,255,255,.22)',
  green: '#40A870',
  red: '#E05050',

  // Тёмная космо-тема (HomeScreen, Figma "ESOTERRA")
  night: 'radial-gradient(140% 90% at 75% 40%, #412782 0%, #311d62 32%, #100a29 68%, #00000d 100%)',
  nightCard: 'rgba(255,255,255,0.06)',
  nightBorder: 'rgba(201,131,223,0.25)',
  goldText: 'linear-gradient(180deg, #ffffff 20%, #c983df 85%)',
  violetBtn: 'linear-gradient(180deg, #a15fd6 0%, #5b2f96 55%, #3a1c66 100%)',
};
